/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHasUnconnectedDocuments} from './IHasUnconnectedDocuments';
import TSAbstractEntity from './TSAbstractEntity';
import TSFremdkostenDaten from './TSFremdkostenDaten';
import {TSSerializable} from './TSSerializable';

export default class TSFremdkosten extends TSAbstractEntity implements TSSerializable<TSFremdkosten>, IHasUnconnectedDocuments {

    private _fremdkostenDatenGS: TSFremdkostenDaten | undefined;

    private _fremdkostenDatenFS: TSFremdkostenDaten;

    private _documentIdsToConnect: Array<string> = [];

    private _schaetzung: boolean;

    deserialize(restObject: any): TSFremdkosten {
        super.deserialize(restObject);
        this.schaetzung = restObject.schaetzung;

        this.fremdkostenDatenFS = this.deserializeOrCreate(restObject.fremdkostenDatenFS, new TSFremdkostenDaten());
        this.fremdkostenDatenGS = this.deserializeOrNull(restObject.fremdkostenDatenGS, new TSFremdkostenDaten());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.schaetzung = this.schaetzung;

        restObject.fremdkostenDatenGS = this.serializeOrInit(this.fremdkostenDatenGS, restObject.fremdkostenDatenGS);
        restObject.fremdkostenDatenFS = this.serializeOrInit(this.fremdkostenDatenFS, restObject.fremdkostenDatenFS);
        return restObject;
    }

    public static getDeserializer = (fremdkosten: any) => {
        return new TSFremdkosten().deserialize(fremdkosten);
    };

    public static getSerializer = (fremdkosten: any) => {
        return fremdkosten.serialize(fremdkosten);
    };

    public get fremdkostenDatenGS(): TSFremdkostenDaten | any {
        return this._fremdkostenDatenGS;
    }

    public set fremdkostenDatenGS(value: TSFremdkostenDaten | any) {
        this._fremdkostenDatenGS = value;
    }

    public get fremdkostenDatenFS(): TSFremdkostenDaten {
        return this._fremdkostenDatenFS;
    }

    public set fremdkostenDatenFS(value: TSFremdkostenDaten) {
        this._fremdkostenDatenFS = value;
    }

    public get documentIdsToConnect(): Array<string> {
        return this._documentIdsToConnect;
    }

    public set documentIdsToConnect(value: Array<string>) {
        this._documentIdsToConnect = value;
    }

    public get schaetzung(): boolean {
        return this._schaetzung;
    }

    public set schaetzung(value: boolean) {
        this._schaetzung = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSFremdkosten.ts